
      // The hero loop is decoration; anyone who has asked for less motion gets
      // its first frame instead.
      const hero = document.querySelector(".hero__media");
      const still = window.matchMedia("(prefers-reduced-motion: reduce)");
      const settle = () => (still.matches ? hero.pause() : hero.play().catch(() => {}));
      still.addEventListener("change", settle);
      settle();

      // Screenshots open full size in a lightbox. They are plain links, so
      // without this script they still open the image.
      const box = document.querySelector("dialog.lightbox");
      const image = box.querySelector("img");
      const caption = box.querySelector("p");
      for (const link of document.querySelectorAll(".feature__shot")) {
        link.addEventListener("click", (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey) return;
          event.preventDefault();
          const thumb = link.querySelector("img");
          image.src = link.href;
          image.alt = thumb.alt;
          caption.textContent = link.dataset.caption ?? "";
          box.showModal();
        });
      }
      box.querySelector("button").addEventListener("click", () => box.close());
      box.addEventListener("click", (event) => {
        if (event.target === box) box.close();
      });
    